import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { applyDir } from './rtl';

// Import the existing translation files instead of using HTTP backend
// This works better with the existing structure
import enCommon from './locales/en.json';
import deCommon from './locales/de.json';
import arCommon from './locales/ar.json';
import svCommon from './locales/sv.json';
import daCommon from './locales/da.json';
import frCommon from './locales/fr.json';

const resources = {
  en: {
    translation: enCommon
  },
  'en-US': {
    translation: enCommon
  },
  de: {
    translation: deCommon
  },
  'de-DE': {
    translation: deCommon
  },
  'sv-SE': {
    translation: svCommon
  },
  'da-DK': {
    translation: daCommon
  },
  'fr-FR': {
    translation: frCommon
  },
  'ar': {
    translation: arCommon
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'ar', 'sv', 'da', 'fr', 'en-US', 'de-DE', 'sv-SE', 'da-DK', 'fr-FR'],
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    
    react: {
      useSuspense: false,
    },
    
    debug: process.env.NODE_ENV === 'development',
  });

// Apply RTL/LTR direction when language changes
i18n.on('languageChanged', (lng) => {
  applyDir(lng);
  
  // Update URL parameter
  const url = new URL(window.location.href);
  url.searchParams.set('lang', lng);
  window.history.replaceState({}, '', url.toString());
});

// Apply initial direction
applyDir(i18n.language || 'en');

export default i18n;

// Language configuration
const LANGUAGE_CONFIG: Record<string, { dir: 'ltr' | 'rtl' }> = {
  'en': { dir: 'ltr' },
  'en-US': { dir: 'ltr' },
  'de': { dir: 'ltr' },
  'de-DE': { dir: 'ltr' },
  'sv-SE': { dir: 'ltr' },
  'da-DK': { dir: 'ltr' },
  'fr-FR': { dir: 'ltr' },
  'ar': { dir: 'rtl' },
  'he': { dir: 'rtl' }
};

// Initialize RTL support on initial load
const initialLng = i18n.language || 'en';
const initialConfig = LANGUAGE_CONFIG[initialLng] || LANGUAGE_CONFIG['en'];
document.documentElement.dir = initialConfig.dir;
document.documentElement.lang = initialLng;

if (initialConfig.dir === 'rtl') {
  document.body.classList.add('rtl');
} else {
  document.body.classList.add('ltr');
}